import { useState } from "react";
import { Img, DemoAction, Chip } from "./shared";

const AREAS = [
  { t: "Dachstuhl", d: "Neubau und Sanierung von Dachstühlen inklusive Statik-Abstimmung.", k: "craft2", p: ["Abbund", "Montage", "Dämmung"] },
  { t: "Holzfassade", d: "Langlebige Fassaden aus heimischem Lärchen- und Fichtenholz.", k: "craft1", p: ["Planung", "Lattung", "Oberfläche"] },
  { t: "Innenausbau", d: "Treppen, Böden und Wandverkleidungen millimetergenau gefertigt.", k: "craft3", p: ["Aufmaß", "Fertigung", "Einbau"] },
];

export default function Handwerk({ wide, onCta }) {
  const [a, setA] = useState(0);
  const cur = AREAS[a];
  return (
    <div className="bg-white text-[#111]" style={{ fontFamily: "'Archivo Variable', sans-serif" }}>
      <div className="bg-[#111] px-5 pt-11 pb-2 text-[11px] font-semibold text-[#FFD400]" style={wide ? { paddingTop: 10, paddingLeft: 48 } : undefined}>
        Notdienst-Hotline in der Studie: 0000 000 000
      </div>
      <header className="flex items-center justify-between border-b-4 border-[#FFD400] px-5 py-3" style={wide ? { paddingLeft: 48, paddingRight: 48 } : undefined}>
        <span className="text-[20px] uppercase" style={{ fontFamily: "'Archivo Black', sans-serif" }}>Holzbau<span className="text-[#E0B800]">.</span>Moser</span>
        <span className="rounded bg-[#FFD400] px-3 py-1.5 text-[12px] font-bold">Angebot</span>
      </header>
      <section className={wide ? "grid grid-cols-2" : ""}>
        <div className={wide ? "flex flex-col justify-center px-12 py-14" : "px-5 py-8"}>
          <span className="w-fit bg-[#FFD400] px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide">Zimmerei · Meisterbetrieb (fiktiv)</span>
          <h1 className={`mt-4 uppercase leading-[0.95] ${wide ? "text-[58px]" : "text-[38px]"}`} style={{ fontFamily: "'Archivo Black', sans-serif" }}>
            Holz, das<br />hält, was<br />es zeigt.
          </h1>
          <ul className="mt-5 space-y-1.5 text-[14px] font-medium">
            {["Dachstuhl & Sanierung", "Holzfassaden", "Innenausbau"].map((x) => (
              <li key={x} className="flex items-center gap-2"><span className="h-2 w-2 bg-[#FFD400]" />{x}</li>
            ))}
          </ul>
        </div>
        <div className={wide ? "h-[460px]" : "h-[220px]"}><Img k="craft2" alt="Zimmerer bei der Arbeit" /></div>
      </section>
      <section className={wide ? "px-12 py-14" : "px-5 py-8"}>
        <h2 className="text-[22px] uppercase" style={{ fontFamily: "'Archivo Black', sans-serif" }}>Leistungsbereiche</h2>
        <div className="no-scrollbar mt-4 flex gap-2 overflow-x-auto">
          {AREAS.map((x, i) => (
            <Chip key={x.t} active={a === i} onClick={() => setA(i)} activeCls="bg-[#111] text-[#FFD400]" idleCls="bg-[#F1F1F1] text-[#111]" className="rounded px-4 py-2.5 text-[13px] font-bold">{x.t}</Chip>
          ))}
        </div>
        <div className={wide ? "mt-6 grid grid-cols-2 gap-8" : "mt-4"}>
          <div className={wide ? "h-[300px]" : "h-[180px]"}><Img k={cur.k} alt={cur.t} /></div>
          <div className={wide ? "" : "mt-4"}>
            <h3 className="text-[20px] font-bold">{cur.t}</h3>
            <p className="mt-2 text-[14px] leading-relaxed text-[#444]">{cur.d}</p>
            <ol className="mt-4 grid grid-cols-3 gap-2">
              {cur.p.map((s, i) => (
                <li key={s} className="border-t-4 border-[#FFD400] pt-2 text-[12px] font-bold"><span className="block text-[#777]">0{i + 1}</span>{s}</li>
              ))}
            </ol>
            <DemoAction label="Rückruf anfordern" onCta={onCta} className="mt-6 w-full rounded bg-[#111] py-3.5 text-[14px] font-bold text-[#FFD400]" />
          </div>
        </div>
      </section>
    </div>
  );
}
